import {
  GET_ORGANIZATION_IAAC,
  GET_ORGANIZATION_IAAC_SUCCESSFUL,
  GET_ORGANIZATION_IAAC_FAILURE,
  GET_ORGANIZATION_IAAC_LICENSES,
  GET_ORGANIZATION_IAAC_LICENSES_SUCCESSFUL,
  GET_ORGANIZATION_IAAC_LICENSES_FAILURE,
  POST_ORGANIZATION_IAAC,
  POST_ORGANIZATION_IAAC_SUCCESSFUL,
  POST_ORGANIZATION_IAAC_FAILURE,
  PUT_ORGANIZATION_IAAC,
  PUT_ORGANIZATION_IAAC_SUCCESSFUL,
  PUT_ORGANIZATION_IAAC_FAILURE,
  PUT_ORGANIZATION_IAAC_SUBSCRIPTION,
  DELETE_ORGANIZATION_IAAC,
  DELETE_ORGANIZATION_IAAC_SUCCESSFUL,
  DELETE_ORGANIZATION_IAAC_FAILURE,
  CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES_SUCCESSFUL
} from "./actionTypes";

const initialState = {
  isGettingOrganizationIaac: false,
  getOrganizationIaacMessage: null,
  getOrganizationIaacError: null,
  iaac: null,
  iaacLicenses: null,
  isGettingOrganizationIaacLicenses: false,
  getOrganizationIaacLicensesError: null,

  isCreatingOrganizationIaac: false,
  createOrganizationIaacMessage: null,
  createOrganizationIaacError: null,

  isUpdatingOrganizationIaac: false,
  updateOrganizationIaacMessage: null,
  updateOrganizationIaacError: null,

  isDeletingOrganizationIaac: false,
  deleteOrganizationIaacMessage: null,
  deleteOrganizationIaacError: null,
};

const organizationIaac = ( state = initialState, action ) => {
  console.log("organizationIaac Reducer, action: ", action);
  switch(action.type){
    case GET_ORGANIZATION_IAAC:
      state = {
        ...state,
        isGettingOrganizationIaac: true,
        getOrganizationIaacMessage: null,
        getOrganizationIaacError: null,
        orgCode: action.payload.orgCode,
      };
      break;
    case GET_ORGANIZATION_IAAC_SUCCESSFUL:
      state = {
        ...state,
        isGettingOrganizationIaac: false,
        iaac: action.payload.iaac,
        getOrganizationIaacMessage: "Organization Iaac was successfully retrieved"
      };
      break;
    case GET_ORGANIZATION_IAAC_FAILURE:
      state = {
        ...state,
        isGettingOrganizationIaac: false,
        getOrganizationIaacError: action.payload.getOrganizationIaacError.message
      };
      break;
    case GET_ORGANIZATION_IAAC_LICENSES:
      state = {
        ...state,
        isGettingOrganizationIaacLicenses: true,
        getOrganizationIaacLicensesError: null,
      };
      break;
    case GET_ORGANIZATION_IAAC_LICENSES_SUCCESSFUL:
      state = {
        ...state,
        isGettingOrganizationIaacLicenses: false,
        iaacLicenses: action.payload.iaacLicenses,
        getOrganizationIaacLicensesError: null,
      };
      break;
    case GET_ORGANIZATION_IAAC_LICENSES_FAILURE:
      state = {
        ...state,
        isGettingOrganizationIaacLicenses: false,
        getOrganizationIaacLicensesError: action.payload.getOrganizationIaacLicensesError.message
      };
      break;
    case POST_ORGANIZATION_IAAC:
      state = {
        ...state,
        isCreatingOrganizationIaac: true,
        iaacRequest: action.payload.iaacRequest,
        createOrganizationIaacMessage: null,
        createOrganizationIaacError: null,
      };
      break;
    case POST_ORGANIZATION_IAAC_SUCCESSFUL:
      state = {
        ...state,
        isCreatingOrganizationIaac: false,
        iaac: action.payload.iaac,
        createOrganizationIaacMessage: "Organization Iaac was successfully created"        
      };
      break;
    case POST_ORGANIZATION_IAAC_FAILURE:
      state = {
        ...state,
        isCreatingOrganizationIaac: false,
        createOrganizationIaacError: action.payload.createOrganizationIaacError.message
      };
      break;
    case PUT_ORGANIZATION_IAAC:
    case PUT_ORGANIZATION_IAAC_SUBSCRIPTION:
      state = {
        ...state,
        isUpdatingOrganizationIaac: true,
        iaacRequest: action.payload.iaacRequest || action.payload.iaac,
        updateOrganizationIaacMessage: null,
        updateOrganizationIaacError: null,
      };
      break;
    case PUT_ORGANIZATION_IAAC_SUCCESSFUL:
      state = {
        ...state,
        isUpdatingOrganizationIaac: false,
        // iaac: action.payload.iaac,
        updateOrganizationIaacMessage: "Organization Iaac was successfully updated with message " + 
                                            action.payload.updateOrganizationIaacMessage
      };
      break;
    case PUT_ORGANIZATION_IAAC_FAILURE:
      state = {
        ...state,
        isUpdatingOrganizationIaac: false,
        updateOrganizationIaacError: action.payload.updateOrganizationIaacError.message
      };
      break;
      case DELETE_ORGANIZATION_IAAC:
        state = {
          ...state,
          isDeletingOrganizationIaac: true,
          orgCode: action.payload.orgCode,
          deleteOrganizationIaacMessage: null,
          deleteOrganizationIaacError: null,
        };
        break;
      case DELETE_ORGANIZATION_IAAC_SUCCESSFUL:
        state = {
          ...state,
          isDeletingOrganizationIaac: false,
          deleteOrganizationIaacMessage: action.payload.deleteOrganizationIaacMessage
          // deleteOrganizationIaacMessage: action.payload.deleteOrganizationIaacMessage.message
        };
        break;
      case DELETE_ORGANIZATION_IAAC_FAILURE:
        state = {
          ...state,
          isDeletingOrganizationIaac: false,
          deleteOrganizationIaacError: action.payload.deleteOrganizationIaacError.message
        };
        break;      
    case CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES_SUCCESSFUL:
        state = {
          ...state,
          getOrganizationIaacMessage: null,
          getOrganizationIaacError: null,
          updateOrganizationIaacMessage: null,
          updateOrganizationIaacError: null,
          createOrganizationIaacMessage: null,
          createOrganizationIaacError: null,
          deleteOrganizationIaacMessage: null,
          deleteOrganizationIaacError: null,
          getOrganizationIaacLicensesError: null,
        };
        break;
    default:
      return state;
  }
  return state;

}

export default organizationIaac;